import { ObtenerCatalogo, Cargando, Error } from "../Types/Catalogo.type";

const INITIAL_STATE = {
  Catalogo: [],
  Resultado: "",
  Mensaje: "",
  Cargando: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ObtenerCatalogo:
      return {
        ...state,
        Catalogo: action.payload,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    case Cargando:
      return {
        ...state,
        Resultado: "",
        Mensaje: "",
        Cargando: true,
      };
    case Error:
      return {
        ...state,
        Resultado: "E",
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    default:
      return state;
  }
};
